import { Box, Card, Divider, Modal, Typography } from '@mui/material'
import React, { Fragment, useState } from 'react'
import EditIcon from '@mui/icons-material/Edit'
import { transformDetailWithPhone } from '../utils/transformDetail'
import { mainGreen, mainGrey } from '../utils/color'
import ImageViewerModal from './ImageViewerModal'

export default function StatisticUpdateHistoryModal({ open, onClose, updateHistory }) {
	const [openImageViewer, setOpenImageViewer] = useState(null)

	return (
		<Modal open={open} onClose={onClose} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
			<Box sx={styles.modal}>
				{updateHistory?.map((order, index) => {
					return (
						<Card
							sx={{
								padding: '10px 20px',
								background: '#fff',
								textAlign: 'left',
								borderRadius: '12px',
							}}
							key={index}
							onClick={(e) => {
								e.stopPropagation()
							}}>
							{index === 0 && (
								<Typography
									sx={{
										display: 'inline-flex',
										alignItems: 'flex-start',
										color: '#fff',
										background: mainGreen,
										padding: '2px 10px',
										borderRadius: '10px',
										mb: 1,
									}}>
									<EditIcon sx={{ fontSize: '20px', marginRight: '5px' }} /> Nhập đơn
								</Typography>
							)}
							{index > 0 && (
								<Typography
									sx={{
										display: 'inline-flex',
										alignItems: 'flex-start',
										color: '#fff',
										background: mainGreen,
										padding: '2px 10px',
										borderRadius: '10px',
										mb: 1,
									}}>
									<EditIcon sx={{ fontSize: '20px', marginRight: '5px' }} /> Chỉnh sửa lần {index}
								</Typography>
							)}
							{index > 0 && (
								<>
									<Typography>
										<b>Người chỉnh sửa: </b>
										{order.editor?.name}
									</Typography>
									<Typography>
										<b>Thời gian chỉnh sửa: </b>
										{order.timeStamp}
									</Typography>
									<Divider sx={{ mb: 1, mt: 1 }} />
								</>
							)}

							<Typography>
								<b>Khối lượng: </b>
								{order.orderData.quantity}kg
							</Typography>
							<Typography>
								<b>Tiền: </b>
								{order.orderData.totalPrice?.toLocaleString()}đ{' '}
								{order.orderData.payment === 'transfer' && (
									<span style={{ color: mainGreen }}>
										<b>(Chuyển khoản)</b>
									</span>
								)}
							</Typography>
							<Typography>
								<b>Thông tin: </b>
								{order.orderData.detail && (
									<span
										dangerouslySetInnerHTML={{
											__html: transformDetailWithPhone(order.orderData.detail),
										}}></span>
								)}
							</Typography>
							{order.orderData.tag?.map((tag, index) => {
								return (
									<Typography
										sx={{
											display: 'inline-block',
											fontSize: '12px',
											padding: '2px 10px',
											borderRadius: '10px',
											color: '#fff',
											background: `${tag.color}`,
											mr: 1,
										}}
										key={index}>
										{tag?.name}
									</Typography>
								)
							})}
							<Box>
								{order.orderData.photoAttach.map((photo, index) => {
									return (
										<Fragment key={index}>
											<img
												loading='lazy'
												src={photo}
												onClick={(e) => {
													e.stopPropagation()
													setOpenImageViewer(photo)
												}}
												width='48'
												height='48'
												style={{
													marginRight: '8px',
													marginTop: '5px',
													cursor: 'pointer',
												}}
												alt=''
											/>
										</Fragment>
									)
								})}
							</Box>
						</Card>
					)
				})}

				<ImageViewerModal open={!!openImageViewer} onClose={() => setOpenImageViewer(null)} src={openImageViewer} />
			</Box>
		</Modal>
	)
}

const styles = {
	modal: {
		background: mainGrey,
		padding: '16px',
		maxHeight: '90vh',
		borderRadius: '12px',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-end',
		overflowY: 'auto',
		gap: 2,
		width: '80vw',
		maxWidth: '500px',
		// alignItems: 'center',
	},
}

